module.exports = __webpack_public_path__ + "static/assets/35dfa130d2fb94543a7d5d590ab04967.svg";